import { LineChartProps } from '@mui/x-charts-pro';

export const percentageSeries = (
  series: LineChartProps['series'],
): LineChartProps['series'] =>
  series?.map(serie => ({
    ...serie,
    valueFormatter: percentageValueFormatter(3),
  }));

export const percentageValueFormatter = (fractionDigits: number) => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  });
  return (value: number) => numberFormatter.format(value);
};

export const compactNumberValueFormatter = () => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  });
  return (value: number) => numberFormatter.format(value);
};
